import type { IAction } from '../../action/IAction'
import { ActionArgs } from '../../action/ActionArgs'
import { Field, ID, InputType } from 'type-graphql'
import GraphQLJSON from 'graphql-type-json'
import type { PaymentLinkLineItem } from '../../payment/PaymentLinkLineItem'

@InputType()
export class CreateOrderPaymentLinkArgs extends ActionArgs {
  @Field(() => ID)
  orderId: string

  @Field(() => String, { nullable: true })
  userId?: string

  // Client-provided line items (e.g. the invoice "Pay Balance" flow charging a single
  // balance amount). Omitted/empty means the order's own items/shipping/tax/discount are used.
  @Field(() => GraphQLJSON, { nullable: true })
  lineItems?: PaymentLinkLineItem[]

  @Field(() => Boolean, { nullable: true })
  fromCheckout?: boolean
}

// TResult is the payment link URL. A single-field return does not warrant a Result class
// (backend-action-style-guide.md) — the caller (PaymentLinkRouter) wraps it as { url }.
export interface ICreateOrderPaymentLink extends IAction<string, CreateOrderPaymentLinkArgs> {}
